module.exports = __webpack_public_path__ + "media/images/captcha-example-53a2ac1014b72c40708e6bd2daf90471.png";